import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import * as _ from "lodash";
import * as moment from "moment";
import { Alert } from "src/app/shared/class/Alert";
import { Pdf } from "src/app/shared/class/Pdf.class";
import { Helper } from "src/app/shared/helpers/helper";
import { UserTypePipe } from "src/app/shared/pipe/user-type.pipe";
export class ReportAccessComponent {
    constructor(authService, reportService, spinner, fb) {
        this.authService = authService;
        this.reportService = reportService;
        this.spinner = spinner;
        this.fb = fb;
        this.goback = "";
        this.userLogged = {};
        this.users = [];
        this.startLastAccess = new FormControl();
        this.minStartLastAccess = new Date();
        this.strStartLastAccess = "";
        this.endLastAccess = new FormControl();
        this.minEndLastAccess = null;
        this.strEndLastAccess = "";
        this.userLogged = this.authService.getUserLogged();
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.form = new FormGroup({
                startLastAccess: new FormControl(""),
                endLastAccess: new FormControl(""),
            });
        });
    }
    onChangeStartDate(event) {
        this.strStartLastAccess = Helper.getFormattedBrDate(event.value);
        this.endLastAccess = new FormControl();
        this.minEndLastAccess = new Date(event.value);
        this.strEndLastAccess = "";
        this.form.controls.endLastAccess.setValue("");
        this.form.controls.endLastAccess.updateValueAndValidity();
    }
    onChangeEndDate(event) {
        this.strEndLastAccess = Helper.getFormattedBrDate(event.value);
    }
    clearPeriod() {
        this.strStartLastAccess = "";
        this.form.controls.startLastAccess.setValue("");
        this.form.controls.startLastAccess.updateValueAndValidity();
        this.strEndLastAccess = "";
        this.form.controls.endLastAccess.setValue("");
        this.form.controls.endLastAccess.updateValueAndValidity();
    }
    onSubmit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validateForm()) {
                const data = yield this.reportService.getAccess(this.getQueryParams());
                this.users = data;
                this.users.sort((a, b) => (a.lastAccess < b.lastAccess ? -1 : 1));
                console.log(data);
                this.viewPdf();
            }
            else {
                Alert.warning(Alert.getMessage().errors.requiredFilters);
            }
        });
    }
    getQueryParams() {
        const params = [];
        const filters = this.form.controls;
        if (!_.isNull(filters.startLastAccess.value) &&
            filters.startLastAccess.value !== "") {
            params.push({
                id: "startLastAccess",
                value: moment(filters.startLastAccess.value).format("YYYY-MM-DD"),
            });
        }
        if (!_.isNull(filters.endLastAccess.value) &&
            filters.endLastAccess.value !== "") {
            params.push({
                id: "endLastAccess",
                value: moment(filters.endLastAccess.value).format("YYYY-MM-DD"),
            });
        }
        return this.prepareQueryParams(params);
    }
    prepareQueryParams(params) {
        let queryParams = "";
        params.map((param) => {
            queryParams = queryParams === "" ? "" : `${queryParams}&`;
            queryParams = `${queryParams}${param.id}=${param.value}`;
        });
        return queryParams;
    }
    validateForm() {
        if (this.form.controls.startLastAccess.value !== "" ||
            this.form.controls.endLastAccess.value !== "" ||
            this.form.controls.company.value !== "" ||
            this.form.controls.agent.value !== "") {
            return true;
        }
        else {
            return false;
        }
    }
    viewPdf() {
        const pdf = this.makePdf(this.users);
        window.open(URL.createObjectURL(pdf.output("blob")));
    }
    makePdf(users) {
        // tslint:disable: max-line-length
        const pdf = new Pdf({
            documentTitle: `Relatório Solicitações de Serviço.pdf`,
            header: true,
            footer: true,
        });
        pdf.setFont("times");
        pdf.pullLine(8);
        pdf.writeClauseTitle("RELATÓRIO DE ACESSO");
        pdf.pullLine(10);
        if (users.length > 1) {
            pdf.writeJustifyText({
                text: `(${users.length}) Acessos encontrados`,
            });
        }
        else {
            pdf.writeJustifyText({
                text: `(${users.length}) Acesso encontrado`,
            });
        }
        pdf.pullLine(10);
        const userTypePipe = new UserTypePipe();
        users.map((user) => {
            pdf.writeJustifyText({
                text: `Nome: ${user.name}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Tipo: ${userTypePipe.transform(user.type)}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Login: ${user.username}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Último Acesso: ${moment(user.lastAccess).format("DD/MM/YYYY")}`,
            });
            pdf.pullLine(8);
            pdf.setLineWidth(0.1);
            pdf.line(10, pdf.getY(), 200, pdf.getY());
            pdf.pullLine(8);
        });
        pdf.pullLine(15);
        return pdf;
    }
}
